/// <reference path="./SelectorItem.ts" />
namespace HA.Core.HTML.Editor {
    export class FileContainer extends FlexContainer {
        public getFileData() {
            return this.get("fdata");
        }

        public getFile() {
            return this.get("f");
        }

        protected initialize(data: any) {
            super.initialize(data);
            const file = this.getFile();
            const reader = new FileReader();
            const me = this;

            reader.onload = (event: ProgressEvent | any) => {
                me.addToData("fdata",
                    {
                        date: file.lastModified,
                        fileData: event.target.result,
                        name: file.name,
                        size: file.size,
                        type: file.type,
                    });
            };

            reader.readAsDataURL(file);

        }
    }
}
